// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"fZ-z","trustedRetailerTooltipWrapper":"gZ-z"};